module.exports = "https://coursera_assets.s3.amazonaws.com/images/8fd599655a50f148c80d763df7b0e5e3.png";